import { GetterTree } from "vuex";
import { RootState } from "@/store/root";
import { FilterState } from "@/store/modules/filters/filterTypes";

export const getters: GetterTree<FilterState, RootState> = {
	filters(state) {
		return JSON.parse(JSON.stringify(state.filters));
	},
};
